import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, PencilLineIcon } from 'lucide-react';
import { PosterFallback } from '../components/PosterFallback';
import { ProductionCard } from '../components/ProductionCard';
import { useAuth } from '../contexts/AuthContext';
import { useCatalog } from '../contexts/CatalogContext';
import { aboutContent, brand } from '../data/siteContent';
import { buttonClass, pagePadding } from '../utils/styles';
export function About() {
  const {
    session
  } = useAuth();
  const {
    published
  } = useCatalog();
  const works = published.slice(0, 4);
  return <div className={`pb-24 pt-28 md:pt-36 ${pagePadding}`} data-id="element-293" data-mp="2sawhrnnqtr4m">
      <section aria-labelledby="about-title" className="grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-294" data-mp="2schglph3bw8a">
        <div className="lg:col-span-5" data-id="element-295" data-mp="2xb12jpvop80n">
          <div className="relative aspect-[4/5] overflow-hidden rounded-lg bg-coal" data-id="element-296" data-mp="1guolg3ywnc1e">
            {aboutContent.portraitUrl ? <img src={aboutContent.portraitUrl} alt={aboutContent.portraitAlt} className="h-full w-full object-cover" data-id="element-297" data-mp="1lvce0u2s80xq" /> : <PosterFallback data-id="element-298" data-mp="1piypj5a4gs92" />}
          </div>
          {!aboutContent.portraitUrl && session && <p className="mt-3 flex items-center gap-2 text-xs text-mist" data-id="element-299" data-mp="23izscq9y69r6">
              <PencilLineIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-300" data-mp="1yjdeqfq7irhu" />
              Fotografía opcional: añádela en el contenido editable del sitio.
            </p>}
        </div>

        <div className="flex flex-col justify-end lg:col-span-7" data-id="element-301" data-mp="2deba7hgnjx35">
          <p className="text-sm font-semibold text-mist" data-id="element-302" data-mp="28h1j7xdm7dd7">Sobre Nicole</p>
          <h1 id="about-title" className="mt-3 font-display text-6xl font-black uppercase leading-none tracking-tight md:text-8xl xl:text-9xl" data-id="element-303" data-mp="2m7wl2ppp4u7a">
            Nicole
          </h1>
          <p className="mt-6 font-display text-xl font-semibold text-white md:text-2xl" data-id="element-304" data-mp="2w6m5ap52eqqp">«{brand.slogan}».</p>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-mist md:text-lg" data-id="element-305" data-mp="2r8u22yyyzi77">
            {aboutContent.introduction ?? 'Creadora audiovisual. NICOLE es el espacio oficial donde se estrenan y reúnen sus producciones originales.'}
          </p>

          {aboutContent.vision ? <div className="mt-10 border-l-2 border-white pl-6" data-id="element-306" data-mp="1xv2q2vbxcdmr">
              <h2 className="font-display text-lg font-bold" data-id="element-307" data-mp="22m19i3s7lru8">Visión artística</h2>
              <p className="mt-3 max-w-xl leading-relaxed text-mist" data-id="element-308" data-mp="22o4blm6mzbfb">{aboutContent.vision}</p>
            </div> : session && <div className="mt-10 rounded-md border border-dashed border-graphite p-5 text-sm text-mist" data-id="element-309" data-mp="2cj5z6dl9k5fs">
                <p className="font-medium text-white" data-id="element-310" data-mp="2gn3z2qiexk9w">Visión artística — pendiente</p>
                <p className="mt-1" data-id="element-311" data-mp="2ll5en1gmr1gm">
                  Solo visible para administración. Completa este texto con las palabras de Nicole; no se muestra al público hasta entonces.
                </p>
              </div>}
        </div>
      </section>

      <section aria-labelledby="works-title" className="mt-24" data-id="element-312" data-mp="jnd87l6cprgx">
        <div className="flex items-end justify-between gap-4" data-id="element-313" data-mp="jooa1fg8kp5e">
          <h2 id="works-title" className="font-display text-2xl font-bold md:text-3xl" data-id="element-314" data-mp="ewdboh159bey">Sus producciones</h2>
          {published.length > 0 && <Link to="/buscar" className={buttonClass('ghost', 'sm', 'normal-case tracking-normal')} data-id="element-315" data-mp="9vh864kpfra2">
              Ver todo
              <ArrowRightIcon className="h-4 w-4" data-id="element-316" data-mp="12lz5eoyqyyfk" />
            </Link>}
        </div>
        {works.length > 0 ? <ul className="mt-8 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-317" data-mp="xo62q5wnkmk1">
            {works.map(p => <li key={p.id} data-id="element-318" data-mp="sm8c2qlxaph2">
                <ProductionCard production={p} data-id="element-319" data-mp="omga4wr1bhko" />
              </li>)}
          </ul> : <p className="mt-6 text-mist" data-id="element-320" data-mp="3de0qofdkziro">Las producciones de Nicole aparecerán aquí al publicarse.</p>}
      </section>
    </div>;
}